import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FAQSection() {
  const [openIds, setOpenIds] = useState<number[]>([1]);

  const toggle = (id: number) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">常见问题</h2>
          <div className="w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item) => {
            const isOpen = openIds.includes(item.id);
            return (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between gap-3 p-4 md:p-5 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-2">{item.q}</h3>
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                    isOpen ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}